import type { FaireProductEntity } from "../../entity_types/product";

export const p_f75bp7xbne: FaireProductEntity = {
  token: "p_f75bp7xbne",
  type: "product",
  name: "Christmas Snoopy Ornament",
  brandToken: "b_48a2b17b",
  brandName: "Silk Road Bazaar",
  imageUrl:
    "https://cdn.faire.com/fastly/aeb69032d0dc81eb704c7a335d0feed4d884ecf136ea9037844927112cf7dfc1.jpeg",
  galleryImageUrls: [],
  priceDollars: 12,
  description:
    "This felt ornament is beautifully crafted with intricate details. This handmade ornament is great for year-round decor! We work with women artisans in Kyrgyzstan to handcraft products using natural fibers and eco-friendly resources. All details are hand stitched and embroidered.\n\nOur talented artisans work in the remote regions of Kyrgyzstan. We connect with artists who are far from the capitals, have limited market access and have carried on traditional craft culture.\n\n• *Approximately 5-6 inches in length*",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:24.315Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
